import { createAction } from '@reduxjs/toolkit';

export const triggerButtonClicked = createAction<
  void,
  'creativeHub/linkExistingFiles/triggerButtonClicked'
>('creativeHub/linkExistingFiles/triggerButtonClicked');
